import { useLocation } from "react-router-dom";
import useEntitlement from "@/hooks/useEntitlement";
import Paywall from "@/components/Paywall";
import CelestialLoader from "@/components/CelestialLoader";

// Routes that remain fully accessible after the trial ends so users keep a
// gentle hook back into the app (Today is the "every-day" surface).
// Menu must stay accessible so users can sign out, view account, etc.
const FREE_PATHS = [
  "/app/today",
  "/app/menu",
  "/app/subscribe",
  // Menu sub-pages: legal, account deletion, kundli, life-letter editor remain
  // reachable so the user can still manage their account post-trial.
  "/app/privacy",
  "/app/terms",
  "/app/approach",
  "/app/profile/edit",
];

function isFree(pathname) {
  return FREE_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export default function PaywallGuard({ children }) {
  const { isExpired, loading } = useEntitlement();
  const location = useLocation();

  if (loading) {
    return <CelestialLoader />;
  }
  if (!isExpired) return children;
  if (isFree(location.pathname)) return children;
  return <Paywall onSubscribed={() => window.location.reload()} />;
}
